<template>
    <div class="row">
      <loading v-if="loadingRender"></loading>
        <div class="btn Pointer btn-outline-info d-none" @click="openModal" data-toggle="modal" data-target="#Modal-RegisterCheck">
      <i class="fas fa-list ml-2"></i>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="Modal-RegisterCheck" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="Modal-SettingLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h5 class="modal-title text-dark" id="Modal-SettingLabel">رهگیری ثبت نام</h5>
          </div>
          <div class="modal-body text-right">
            <div class="row px-3">
              <div class="col-12 col-md-12 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-12 text-right">
                      <span class="text-secondary">کدملی : </span>
                      <input type="number" maxlength="10" @keypress="$ValidNumber($event, 10)"  class="form-control text-center" dir="ltr" v-model="CodeMeli" placeholder='کد ملی '/>
                    </div>
                    <div v-if="NotCode" class="col-12 text-right">
                      <span class="text-secondary">کد رهگیری : </span>
                      <input type="number" maxlength="20" @keypress="$ValidNumber($event, 20)"  class="form-control text-center" dir="ltr" v-model="CodeRahgiri" placeholder='کد رهگیری '/>
                    </div>
                    <div class="col-12 mt-1 text-center">
                        <button @click="getData()" class="btn btn-submit w-100 mt-2">جستجو</button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="$router.go(-1)" class="btn btn-secondary" data-dismiss="modal">انصراف</button>
          </div>
        </div>
      </div>
    </div>
        <div class="col-md-2 col-12"></div>
            <div  class="col-md-8 col-12">
                <net-pa-card>
                <template v-slot:header>
                    <h6 class="text-right"><i class="fas fa-cheque ml-2"></i> بررسی وضعیت درخواست عضویت</h6>
                    <button @click="search()" class="btn btn-sm btn-warning NetPa-btn float-left m-1">جستجو</button>
                    <button @click="GoToLogin()" class="btn btn-sm btn-info NetPa-btn float-left m-1">بازگشت</button>

                </template>
                <template slot="content">
                    <div class="row">
                    <div @click="nextPage(1)" class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                        <a class="d-block w-100 h-100" id="head1">احراز هویت</a>
                    </div>
                    <div @click="nextPage(2)" class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                        <a class="d-block w-100 h-100" id="head2">پرداخت حق عضویت</a>
                    </div>
                    <div @click="nextPage(3)" class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                        <a class="d-block w-100 h-100" id="head3">وضعیت تایید</a>
                    </div>
                    <!-- <div @click="nextPage(4)" class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                        <a class="d-block w-100 h-100" id="head1">احراز هویت</a>
                    </div> -->
                    </div>
                    <div class="row mt-3 px-2"> 
                    <div v-if="divToShow == 1 && loading" class="col-12 border bnp-rounded">
                        <div class="col-12 mt-2 mb-4 text-center" v-if="divToShow == 1">
                            <div class="row">
                                <div class="col-md-4 col-12 text-md-left text-center">
                                <i class="fas fa-user-shield text-success fa-5x"></i>
                                </div>
                                <div class="col-md-8 col-12 text-md-right text-center mt-2">
                                <h5 class="mx-2 text-success mb-2">احراز هویت  با موفقیت انجام شده</h5>
                                <h7 class="mx-2 text-success mb-2">اطلاعات هویتی شما (توسط سامانه ثبت احوال) مورد تایید میباشد</h7>
                                </div>
                            </div>
                        </div>
                        <div class="row border-right border-primary my-1 mx-3" style="border-right: 3px solid #007bff !important">
                        <div class="col-12 m-2 border-bottom">
                            <h6>مشخصات</h6>
                        </div>
                        <div class="col-md-6 col-12 my-1">
                            <span class="text-secondary font-weight-bold"> نام:</span>
                            <span class="text-dark"> {{ GatData.ozvName }} </span>
                        </div>
                        <div class="col-md-6 col-12 my-1">
                            <span class="text-secondary font-weight-bold"> نام خانوادگی :</span>
                            <span class="text-dark"> {{ GatData.ozvFamily }}</span>
                        </div>
                        <div class="col-md-6 col-12 my-1" >
                            <span class="text-secondary font-weight-bold"> کدملی  :</span>
                            <span class="text-dark"> {{ GatData.codeMeli }} </span>
                        </div>
                        <div class="col-md-6 col-12 my-1">
                            <span class="text-secondary font-weight-bold"> تاریخ تولد :</span>
                            <span class="text-dark"> {{ GatData.birthDate }} </span>
                        </div>
                        <div class="col-md-6 col-12 my-1">
                            <span class="text-secondary font-weight-bold"> تاریخ درخواست :</span>
                            <span class="text-dark"> {{ GatData.tarixOzv }} </span>
                        </div>
                        </div>
                        <div class="row my-2 px-3">
                            <div class="col-3"></div>
                            <div class="col-3"></div>
                            <div class="col-3"></div>
                            <div class="col-12 col-md-3">
                                <button  @click="nextPage(2)" class="btn btn-success w-100 NetPa-btn">مرحله بعد</button>
                            </div>
                            </div>
                    </div>
                   
                    <div v-if="divToShow == 2 && loading" class="col-12 border bnp-rounded">
                        <form v-if="this.GatData.codeRahgiri=='BnpCo'" id="div1" class="text-center w-100">
                            <div class="row">
                                <div class="col-md-4 col-12">
                                  <input class="form-control mt-2 text-center 3ragham" id="Mab" :disabled="FixVariz" v-model="Mablagh" dir="ltr" type="number" placeholder="مبلغ واریزی" style="font-size: 15px !important" />
                                  <span class="text-danger h6"> {{ $Comma3ragham(Mablagh) }} </span>
                                  <span class=" "> {{ ToPersian(Mablagh) }} ريال </span>

                                </div>
                          
      
                            <div class="col-md-8 col-12">
                                <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
                                <template v-slot:ContentButtonPayment>
                                    <button id="BtnPayment" class="btn w-50" :class="!loading || Number(Mablagh) < 10000 ? 'btn-secondary' : 'btn-success'" :disabled="!loading || Number(Mablagh) < 10000" @click.prevent="Payment">
                                    واریز
                                    {{ $Comma3ragham(Mablagh) }} ريال
                                    </button>
                                </template>
                                </payment>
                            </div>
                            </div>
                        </form>
                        <div v-else>
                          <div class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-success-custom w-100">
                                <i class="fas fa-check-circle text-success" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important">{{ TextVazeiat }}</span>
                          </div>
                              <span class="text-dark text-center" style="font-size: 17px !important">تاریخ : {{ GatData.tarixSanad }}</span>
                              <span class="text-dark text-center mt-3" style="font-size: 17px !important">کد رهگیری : {{ Rahgiri }}</span>
                              <span class="text-dark text-center mt-3" style="font-size: 17px !important"> مشخصات پرداخت کننده :{{  GatData.ozvName +' ' + GatData.ozvFamily }} </span>
                              <span class="text-dark text-center mt-3" style="font-size: 17px !important"> مبلغ پرداختی : {{ $Comma3ragham(GatData.bestan) }} </span>
                            </div>
                        </div>
                        <div class="row my-2 px-3">
                            <div class="col-3"></div>
                            <div class="col-3"></div>
                            <div class="col-3"></div>
                            <div class="col-12 col-md-3">
                                <button  @click="nextPage(3)" class="btn mt-5 btn-success w-100 NetPa-btn">مرحله بعد</button>
                            </div>
                            </div>
                    </div>
                    <div v-if="divToShow == 3 && loading" class="col-12 border bnp-rounded">
                      <div v-if="this.GatData.wwwtblcomboidgrp331==181070520" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-success-custom w-100">
                                <i class="fas fa-times-circle text-success" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما با موفقیت تایید شده است </span>
                          </div>
                        </div>
                        <div v-if="this.GatData.wwwtblcomboidgrp331==181070521" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-danger-custom w-100">
                                <i class="fas fa-times-circle text-danger" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما تایید نشده است  </span>
                          </div>
                          <span class="text-dark text-center" style="font-size: 17px !important">علت رد درخواست : {{ GatData.desState }}</span>

                        </div>
                        <div v-if="this.GatData.wwwtblcomboidgrp331==181070522" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-warning-custom w-100">
                                <i class="fas fa-times-circle text-warning" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما نیاز به اصلاح دارد   </span>
                          </div>
                          <span class="text-dark text-center" style="font-size: 17px !important">توضیحات اصلاح : {{ GatData.desState  }}</span>
                          <button class="btn btn-warning mr-1 mt-3 no-print" type="button" @click="GetRigister(GatData.id)"><span class="mr-2" style="font-size: 17px !important"> اصلاح اطلاعات </span></button>

                        </div>
                        <div v-if="this.GatData.wwwtblcomboidgrp331==181070519 " class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-info-custom w-100">
                                <i class="fas fa-times-circle text-info" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما در حال بررسی میباشد    </span>
                          </div>
                        </div>
                        <div v-if="this.GatData.wwwtblcomboidgrp331==181070518" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                              <div class="alert text-center bg-info-custom w-100">
                                <i class="fas fa-times-circle text-info" style="font-size: 17px !important"></i>
                                <span class="text-dark" style="font-size: 17px !important"> لطفا از مرحله دوم پرداخت حق عضویت را انجام دهید    </span>
                          </div>
                        </div>
                    </div>
                    </div>
                </template>
                </net-pa-card>
            </div>
            <div class="col-md-2 col-12"></div>
  
    </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Payment from '../CmpNetPa/Payment.vue'
import Num2persian from 'num2persian'
import loading from '../Tools/NetPa/Loading.vue'

export default {
    components: { NetPaCard ,Payment,Num2persian,loading},
    data(){
        return{
          NotCode:false,
          loadingRender: false,
          DesState:'',
          Tarix: '',
          Rahgiri:'',
            TextVazeiat : ' تراکنش با موفقیت انجام شد ',
            FixVariz: false,
            GatewayCode: null,
            Mablagh:0,
            divToShow: 1,
            loading:false,
            DataAxios: {
                ArryfildValue: "",
                Method: 'Post',
                Action: 'NewtblAza',
                Token: this.$session.get('TokenNetPa'),
            },
            CodeMeli: '',
            CodeRahgiri : null  , 
            GatData:null,
            DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
        
      },
      WwwtblTaahodatId:0
        }
    },
    methods:{
      GetRigister(rowid){
        console.log(rowid);
        this.$router.push({ name: 'Register', params: {RegisterCheck :rowid} })
      },
      GoToLogin() {
      this.$router.push('/')
    },
        ToPersian(number) {
      return Num2persian(number)
    },
        FixVarizGhest(val) {
      this.FixVariz = val
    },
        Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    Payment() {
          this.SendPayment()
        },
        SendPayment() {
        if(this.Mablagh<JSON.parse($cookies.get('MablaghEftetahHesab'))){
          this.$mySweetDefault('هشدار', 'مبلغ وارد شده از حداقل مبلغ برای حق عضویت کمتر می باشد', 'warning', 3000)
          return;
        }else{

        var formdata = new FormData()
        formdata.append('id', this.CodeRahgiri)
        formdata.append('noeId', Number(JSON.parse($cookies.get('NoeIdPishFarz'))))
        var DataAxios_AzaForEftetahHesab = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'AzaForEftetahHesab',
          Token: '',
        }

        this.$PostFormData(DataAxios_AzaForEftetahHesab)
          .then((data) => {
            if(data.status=="OK"){
              console.log('OK',data);
              this.WwwtblTaahodatId=data.wwwtblTaahodatId
            }
            else if(data.status=="true"){
              console.log('addOK',data);
              this.WwwtblTaahodatId=data.wwwtblTaahodatId
            }
          }).finally(()=>{
            this.Mablagh = this.Mablagh
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.WwwtblTaahodatId,
        Mablagh: Number(this.Mablagh),
        SharhRiz: 'واریز حق عضویت جهت ثبت نام اولیه'+ ' _پرداخت کننده_ ' + this.GatData.ozvName+' ' + this.GatData.ozvFamily + this.GatData.codeMeli.trim(),
        WwwtblAzaId: Number(this.CodeRahgiri*-1),
        BnpCashDBtblTaahodatId: -1,
        BnpCashDBtblAzaId: -1,
        MablaghJarime: 0,
        TarixGhest: this.$store.state.JalaliDate,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh)
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = -1
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = 'واریز حق عضویت جهت ثبت نام اولیه' + ' _پرداخت کننده_ ' + this.GatData.ozvName+' ' + this.GatData.ozvFamily+ this.GatData.codeMeli.trim()
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.CodeRahgiri*-1)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh + '',
            this.GatData.ozvName+' ' + this.GatData.ozvFamily,
            'RegisterCheck',
            this.GatData.mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            0 + '',
            '-1',
            'واریز حق عضویت جهت ثبت نام اولیه',
            Number(this.CodeRahgiri*-1) + '',
            this.$session.get('CustCode'),
            this.GatData.wwwtblShobeId + '',
            result.idRepoMaster,
            this.GatData.codeMeli.trim()
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
          })
      
        }
      
    },
    search(){this.openModal()}
    ,GoToLogin() {
      this.$router.push('/')
    },
    openModal() {
        $('#Modal-RegisterCheck').modal('show')
    },
    closeModal() {
      $('#Modal-RegisterCheck').modal('hide')
    },
        getData(){
          this.closeModal()
            if(this.CodeMeli!=''){
              this.loadingRender=true
              this.loading=false
                const formData = new FormData();
            formData.append("CodeMeli",this.CodeMeli);
            formData.append("CodeRahgiri",this.CodeRahgiri);
            this.DataAxios.ArryfildValue = formData;
            this.$PostFormData(this.DataAxios).then((data) => {
                if(data!=null){
                    console.log(data);
                    this.loading=true
                    this.GatData=data
                    this.Mablagh=JSON.parse($cookies.get('MablaghEftetahHesab'))
                    this.Rahgiri=data.codeRahgiri
                    this.loadingRender=false
          this.closeModal()

                }else{
                    this.loading=false
                    this.loadingRender=false
                this.$mySweetDefault('هشدار', 'کد ملی وارد شده معتبر نیست ', 'warning', 3000)

                }
            })
            }else{
                this.loading=false
                this.loadingRender=false
                this.$mySweetDefault('هشدار', 'کد ملی وارد نشده است ', 'warning', 3000)
            }

        },
        nextPage(number) {
            this.selectCurent(document.getElementById('head' + number), number)
        },
        selectCurent(data, number) {
      var headers = document.getElementsByClassName('hoverHeader')
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index]
        element.classList.remove('current')
      }
      if (data.target) {
        data.target.parentNode.classList.add('current')
      } else {
        data.parentNode.classList.add('current')
      }
      this.divToShow = number
    },
    },
    mounted()
    {
        if(this.$route.params.Status){
            this.CodeRahgiri=this.$route.params.Status
            if(this.CodeRahgiri==0)
            {
              this.NotCode=true
              this.CodeRahgiri=null
            }
            this.openModal()
        }
        // console.log(this.$route.params.Status);
    }
}
</script>
<style scoped>

.hoverHeader:hover {
  font-weight: bold;
  color: darkorchid;
  background: rgb(224, 221, 226);
  cursor: pointer;
  transition: all 0.5s ease-in;
}
.hoverHeader.current {
  font-weight: bold;
  color: #435ebe;
  background: #dee3f5;
  cursor: pointer;
  transition: all 0.5s ease-in;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>

